import React from 'react'

type Props = { location?: string, streamingLink?: string }
const LocationInfo:React.FC<Props> = ({ location, streamingLink }) => {
  const ONLINE_TEXT = 'Online'
  if(streamingLink && location) { return <>{ONLINE_TEXT} & {location}</> }
  if(streamingLink && !location) { return <>{ONLINE_TEXT}</> }
  if(!streamingLink && location) { return <>{location}</>}
  return null
}

export default LocationInfo
